import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import TopBar from "../components/TopBar";

const PROGRAMS = [
  {
    icon: "🎯",
    key: "player_dev",
    title_es: "Player Development",
    title_en: "Player Development",
    price: null,
    features_es: ["Evaluación inicial completa", "Videos Antes/Después", "Skills tracking", "Feedback del coach", "Timeline de progreso"],
    features_en: ["Full initial evaluation", "Before/After videos", "Skills tracking", "Coach feedback", "Progress timeline"],
    desc_es: "El corazón de Soccer Troop. Desarrollo integral del jugador con evidencia visible de progreso a lo largo de meses.",
    desc_en: "The heart of Soccer Troop. Full player development with visible progress evidence over months.",
  },
  {
    icon: "⚽",
    key: "shooting",
    title_es: "Shooting & Finishing",
    title_en: "Shooting & Finishing",
    price: "$70 / 1 player · $100 / 2 players",
    features_es: ["Técnica de definición", "Precisión de tiro", "Toma de decisiones en el área"],
    features_en: ["Finishing technique", "Shot precision", "Decision-making inside the box"],
    desc_es: "Entrenamientos específicos de definición y acabado en el arco.",
    desc_en: "Specialized shooting and finishing training sessions.",
  },
  {
    icon: "👥",
    key: "small_group",
    title_es: "Small Group Training",
    title_en: "Small Group Training",
    price: "$45 per player · 3-6 players",
    features_es: ["Grupos reducidos", "Atención personalizada", "Ejercicios tácticos"],
    features_en: ["Small groups", "Personalized attention", "Tactical drills"],
    desc_es: "Entrenamiento intensivo en grupos pequeños con feedback individual.",
    desc_en: "Intensive small-group training with individual feedback.",
  },
  {
    icon: "🏕️",
    key: "camps",
    title_es: "Camps",
    title_en: "Camps",
    price: null,
    features_es: ["Programas de temporada", "Múltiples sesiones", "Cierre de programa"],
    features_en: ["Season programs", "Multiple sessions", "Program wrap-up"],
    desc_es: "Camps intensivos de temporada. Precio definido por el Admin según duración.",
    desc_en: "Season intensive camps. Price set by Admin per duration.",
  },
  {
    icon: "⭐",
    key: "elite",
    title_es: "Elite / Advanced Development",
    title_en: "Elite / Advanced Development",
    price: null,
    features_es: ["Solo por invitación", "Nivel competitivo", "Preparación avanzada"],
    features_en: ["Invite only", "Competitive level", "Advanced preparation"],
    desc_es: "Programa avanzado para jugadores competitivos. Contactar al coach.",
    desc_en: "Advanced program for competitive players. Contact the coach.",
  },
];

export default function ProgramsPage() {
  const { lang } = useLang();
  const es = lang === "es";
  return (
    <div className="min-h-screen bg-[#080808] text-white">
      <TopBar />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="mb-8">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#e8559a]/80 mb-3">
            Soccer Troop · Denver, CO
          </div>
          <h1 className="font-bebas text-5xl sm:text-6xl tracking-[0.05em]">
            {es ? "PROGRAMAS" : "PROGRAMS"}
          </h1>
          <p className="mt-3 text-neutral-400 max-w-2xl">
            {es
              ? "Cada programa está diseñado para hacer visible el progreso del jugador."
              : "Every program is designed to make player progress visible."}
          </p>
        </div>

        <div className="space-y-4">
          {PROGRAMS.map((p) => (
            <div
              key={p.key}
              data-testid={`prog-${p.key}`}
              className="rounded-2xl bg-[#161616] border border-[#252525] hover:border-[#e8559a]/40 p-6 sm:p-7 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="text-4xl flex-shrink-0">{p.icon}</div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <h2 className="font-bebas text-3xl tracking-wider">
                      {es ? p.title_es : p.title_en}
                    </h2>
                    {p.price && (
                      <span className="px-3 py-1 rounded-full bg-[#e8559a]/10 border border-[#e8559a]/30 text-[#e8559a] text-xs font-medium">
                        {p.price}
                      </span>
                    )}
                  </div>
                  <p className="mt-2 text-neutral-300 text-sm sm:text-base leading-relaxed">
                    {es ? p.desc_es : p.desc_en}
                  </p>
                  <ul className="mt-3 flex flex-wrap gap-2">
                    {(es ? p.features_es : p.features_en).map((f, i) => (
                      <li key={i} className="text-xs px-2.5 py-1 rounded-full bg-[#0f0f0f] border border-[#252525] text-neutral-300">
                        ✓ {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link to="/register" className="px-6 py-3.5 rounded-xl bg-[#e8559a] hover:bg-[#c9407f] text-white font-bebas text-lg tracking-[0.2em] transition-colors shadow-lg shadow-[#e8559a]/30">
            {es ? "REGISTRAR JUGADOR" : "REGISTER PLAYER"} →
          </Link>
          <Link to="/" className="px-6 py-3.5 rounded-xl bg-[#161616] border border-[#252525] hover:border-[#e8559a]/50 text-neutral-200 font-bebas text-lg tracking-[0.2em] transition-colors">
            ← {es ? "INICIO" : "HOME"}
          </Link>
        </div>
      </main>
    </div>
  );
}
